import React, { Component } from "react";
import request, { tracesToken } from "../../lib/requester";
import _ from "lodash";
import { Link } from "react-router-dom";
import moment from "moment";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import axios from "axios";
import { DownloadOutlined } from '@ant-design/icons';
import { Button } from "antd";
class Detail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bankName: "",
      accOwner: "",
      status: "",
      paymentMethod: "",
      norek: "",
      npwp: "",
      skb: "N",
      taxNo: "",
      taxDate: new Date(),
      fileSKB: { filename: "", path: "" },
      fileLain: { filename: "", path: "" },
      fileTambahan: { filename: "", path: "" },
      principalName: "",
      description: "",
      refNumber: "",
      programType: "",
      customerName: "",
      potongTagihan: "",
      pphRate: 1,
      pphType: "",
      dpp: 0,
      ppn: 0,
      pph: 0,
      totalAmount: 0,
      docs: [],
      fileContainer: [],
      error: [],
      listInvoice: [],
      lovPPH: [],
      success: "",
      fileBupot: { filename: "", path: "" },
      user: JSON.parse(window.localStorage.getItem("is_user")) || {},
      submitteddate: "",
      startDate: new Date(),
      endDate: new Date(),
      sisabudget: 0,
      programNumber: "",
      budgetType: "",
      program_budget: 0,
      assign_budget: 0,
      sales_target: 0,
      skpnumber: "",
      claimnumber: "",
    };
  }

  componentDidMount = () => {
    this.getDetailProgram();
    this.getPPhType();
  };

  getPPhType = () => {
    let url = "/api/traces/v1/general/pph-type";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovPPH: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  renderLovPPh = () => {
    return (
      <select
        disabled
        className="form-control"
        name="pphType"
        value={this.state.pphType}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Type -</option>
        {this.state.lovPPH.map((item, index) => (
          <option value={item.pph_type} key={index}>
            {item.pph_type}
          </option>
        ))}
      </select>
    );
  };

  getDetailProgram = () => {
    let url = "/api/traces/v1/claim/detail-by-claimid";
    let { id } = this.props.match.params;
    let param = {
      claim_id: id,
    };
    this.setState({ loading: true });
    request.postTraces(url, param, {
      success: function (response) {
        let { header, claim, attachment, invoice } = response.data.data;
        this.setState({
          loading: false,
          skpnumber: header.skp_number,
          claimnumber: header.claim_number,
          programNumber: header.program_number,
          budgetType: header.budget_type,
          sisabudget: header.sisa_budget,
          program_budget: header.program_budget,
          assign_budget: header.assign_budget,
          sales_target: header.sales_target,
          programCustId: header.program_customer_id,
          // selectedInvoice: invoiceContainer,
          // loading: false,
          branchId: header.branch_id,
          customerId: header.customer_id,
          bankName: claim.bank,
          accOwner: claim.bank_acc_owner,
          principalName: header.org_name,
          refNumber: header.ref_number,
          programType: header.program_name,
          description: header.description,
          customerName: header.customer_name || "",
          dpp: this.thousandSeparator(claim.dpp || 0),
          ppn: this.thousandSeparator(claim.ppn || 0),
          pph: this.thousandSeparator(claim.pph || 0),
          pphRate: claim.pph_rate,
          pphType: claim.pph_type,
          potongTagihan: claim.potong_tagihan,
          docs: attachment,
          listInvoice: invoice,
          paymentMethod: claim.payment_method,
          npwp: claim.npwp,
          norek: claim.no_rekening,
          skb: claim.skb,
          taxNo: claim.tax_no,
          status: claim.status,
          taxDate: moment(claim.tax_date).format("DD-MMM-YYYY"),
          submitteddate: moment(header.creation_date).format("DD-MMM-YYYY"),
          claimExpDate: moment(header.claim_exp_date).format("DD-MMM-YYYY"),
          startDate: moment(header.start_date).format("DD-MMM-YYYY"),
          endDate: moment(header.end_date).format("DD-MMM-YYYY"),
          fileSKB: {
            filename: claim.doc_skb_filename,
            path: claim.doc_skb_path,
            key: claim.doc_mandatory_file_key,
          },
          fileLain: {
            filename: claim.doc_lain_filename,
            path: claim.doc_lain_path,
            key: claim.doc_mandatory_file_key,
          },
          fileTambahan: {
            filename: claim.doc_tambahan_filename,
            path: claim.doc_tambahan_path,
            key: claim.doc_mandatory_file_key,
            claim_id: claim.claim_id,
            doc: 'aditional'
          },
          fileBupot: {
            filename: claim.doc_bupot_filename,
            path: claim.doc_bupot_path,
            key: claim.doc_mandatory_file_key,
            claim_id: claim.claim_id,
            doc: 'mandatory',
            claim_number: header.claim_number
          },
        });
        let app = this;
        window.setTimeout(() => {
          app.calculateAmount();
          console.log(app.state);
        }, 200);
      }.bind(this),
      error: function (e) {
        console.log(e);
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  showError = () => {
    if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
        </div>
      );
    }
  };

  showSuccess = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fas fa-check"></i> {this.state.success}
        </div>
      );
    }
  };

  thousandSeparator = (value) => {
    value = value.toString();
    value = value.replace(/,/g, "").replace(/[^0-9.]/g, "");
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  removeSeparator = (value) => {
    value = value.toString();
    return value.replace(/,/g, "");
  };

  calculateAmount = () => {
    let { dpp, ppn, pph, totalAmount } = this.state;
    totalAmount =
      (parseInt(this.removeSeparator(dpp)) || 0) +
      (parseInt(this.removeSeparator(ppn)) || 0) -
      (parseInt(this.removeSeparator(pph)) || 0);
    let app = this;
    window.setTimeout(() => {
      app.setState({
        totalAmount: this.thousandSeparator(totalAmount),
        ppn: this.thousandSeparator(ppn),
      });
    }, 500);
  };

  handleChangeInput = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    if (name === "pph" || name === "ppn" || name === "dpp") {
      value = this.thousandSeparator(value);
    }

    this.setState({ [name]: value });
    if (name === "pph" || name === "ppn" || name === "dpp") {
      let app = this;
      window.setTimeout(() => {
        app.calculateAmount();
        app.forceUpdate();
      }, 100);
    }
  };

  downloadAttachment = (data, preview) => {
    this.setState({ loading: true });
    let url = data.doc === 'bupot' ?
      `/api/traces/v1/tracking-email/download-surat-refund?bupot_file_key=${data.key}&bupot_filename=${data.filename}` :
      data.doc === 'mandatory' ?
        `/api/traces/v1/tracking-email/download-surat-refund?mandatory_filename=${data.filename}&mandatory_file_key=${data.key}` :
        `/api/traces/v1/tracking-email/download-surat-refund?additional_FileName=${data.filename}&mandatory_file_key=${data.key}`

    request.getTraces(url, {
      success: function (response) {
        if (response.data.statusCode === 400) {
          window.open(data.path, "_blank");
          this.setState({ loading: false });
        } else {
          axios({
            url: response.config.url,
            method: 'GET',
            responseType: 'blob',
            headers: {
              Authorization: `Bearer ${tracesToken()}`,
            },
          }).then((response) => {
            if (preview && preview === 'preview') {
              const objectUrl = URL.createObjectURL(response.data)
              const pdfWindow = window.open();
              pdfWindow.location.href = objectUrl;
              // window.open(response.config.url, "_blank");
              this.setState({ loading: false });
            } else {
              const href = URL.createObjectURL(response.data);
              const link = document.createElement('a');
              link.href = href;
              link.setAttribute('download', data.doc === "bupot" ? `CLAIM_${data.claim_id}.pdf` : data.doc === "mandatory" ? `${data.claim_number.replace(/[/]/g, '')}.pdf` : `${data.filename}.pdf`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(href);
              this.setState({ loading: false });
            }
          })
            .catch(error => {
              window.open(data.path, "_blank");
              this.setState({ loading: false });
            })
        }
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  }

  renderDocument = () => {
    return this.state.docs.map((item, index) => (
      <div className="row border-bottom" key={index}>
        <div className="col-md-2 mt-2">{item.document_name}</div>
        <div className="col-md-6 mt-2">
          <a style={{ color: "blue" }} onClick={() => this.downloadAttachment(item, 'preview')}>
            {item.doc === "mandatory" ? item.claim_number.replace(/[/]/g, '') : item.filename}
          </a>
          <Button type="primary" icon={<DownloadOutlined />} className="ml-3" onClick={() => this.downloadAttachment(item)} />
        </div>
      </div>
    ));
  };

  handleUpload = (e) => {
    if (e.target.files.length === 0) {
      return false;
    }

    let files = e.target.files[0];
    let { programDocId, index } = e.target.dataset;
    // validation
    let filename = files.name;
    var fileExt = filename.split(".").pop();
    var allowedFile = [
      "jpg",
      "png",
      "jpeg",
      "gif",
      "doc",
      "docx",
      "xls",
      "xlsx",
      "csv",
      "pdf",
    ];
    if (allowedFile.indexOf(fileExt) < 0) {
      this.setState({ error: ["File extension not allowed"] });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      return false;
    }

    const data = new FormData();
    data.append("myFile", files, files.name);
    this.setState({ loading: true });
    request.postnobody("/arman/v1/program/upload-file", data, {
      success: function (response) {
        let { data } = response.data;
        let container = this.state.fileContainer;
        data.program_doc_id = programDocId;
        data.index = index;
        container.push(data);
        this.setState({ fileContainer: container, loading: false });
        this.forceUpdate();
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      },
    });
  };

  renderUploadedFile = (index) => {
    let { fileContainer } = this.state;
    let find = _.find(fileContainer, function (o) {
      return parseInt(o.index) === parseInt(index);
    });
    if (find) {
      return (
        <span>
          <Link to={{ pathname: find.path }} target="_blank">
            {find.filename}{" "}
          </Link>
          &nbsp;
          <button
            type="button"
            className="btn btn-danger"
            data-index={index}
            onClick={() => {
              this.removeFile(index);
            }}
          >
            <i className="fas fa-trash-alt"></i>
          </button>
        </span>
      );
    }
  };

  removeFile = (index) => {
    let indexing = _.findIndex(this.state.fileContainer, function (o) {
      return parseInt(o.index) === parseInt(index);
    });
    if (indexing >= 0) {
      let container = this.state.fileContainer;
      container.splice(indexing, 1);
      this.setState(container);
    }
  };

  validateForm = () => {
    let {
      potongTagihan,
      pphRate,
      pphType,
      dpp,
      ppn,
      fileContainer,
      docs,
    } = this.state;
    let error = [];
    if (potongTagihan === "" || potongTagihan.length === 0) {
      error.push("Potong tagihan belum dipilih");
    }
    if (pphRate === 0 || pphRate.length === 0) {
      error.push("PPh Rate belum diinput");
    }
    if (pphType === "") {
      error.push("PPh Type belum dipilih");
    }
    if (parseInt(dpp) === 0 || dpp.length === 0) {
      error.push("DPP belum diinput");
    }
    if (parseInt(ppn) === 0 || ppn.length === 0) {
      error.push("PPn belum diinput");
    }
    if (fileContainer.length < docs.length) {
      error.push("Lampiran dokumen belum lengkap");
    }

    if (error.length > 0) {
      window.scrollTo(0, 0);
      this.setState({ error: error });
      return false;
    } else {
      return true;
    }
  };

  renderTableInvoice = () => {
    if (this.state.paymentMethod === "INV") {
      return (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Invoice Number</th>
              <th>Invoice Amount</th>
              <th>Invoice Date</th>
            </tr>
          </thead>
          <tbody>
            {this.state.listInvoice.map((item, index) => (
              <tr key="index">
                <td>{item.invoice_number}</td>
                <td>{item.invoice_amount}</td>
                <td>
                  {moment(new Date(item.invoice_date)).format("DD-MMM-YYYY")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }
  };

  renderNorek = () => {
    if (this.state.paymentMethod === "TRF") {
      return (
        <div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Account No
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                disabled
                autoComplete="off"
                className="form-control"
                id="inputEmail3"
                name="norek"
                placeholder="No Rekening"
                onChange={this.handleChangeInput.bind(this)}
                value={this.state.norek}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Bank Name
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                disabled
                autoComplete="off"
                className="form-control"
                id="inputEmail3"
                name="norek"
                placeholder="Bank Name"
                onChange={this.handleChangeInput.bind(this)}
                value={this.state.bankName}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Account Owner
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                disabled
                autoComplete="off"
                className="form-control"
                id="inputEmail3"
                name="norek"
                placeholder="Account Owner"
                onChange={this.handleChangeInput.bind(this)}
                value={this.state.accOwner}
              />
            </div>
          </div>
        </div>
      );
    }
  };

  renderTax = () => {
    let { ppn } = this.state;
    if (parseInt(this.removeSeparator(ppn)) > 0) {
      return (
        <div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Tax No
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                disabled
                autoComplete="off"
                className="form-control"
                id="inputEmail3"
                name="taxNo"
                placeholder="Tax No"
                onChange={this.handleChangeInput.bind(this)}
                value={this.state.taxNo}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Tax Date
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                disabled
                className="form-control"
                value={this.state.taxDate}
              />
            </div>
          </div>
        </div>
      );
    }
  };

  handleRedirect = (e) => {
    const url = request.getFileS3('skb', this.state.fileSKB.filename);
    if (url && url.length > 0) {
      window.open(url, '_blank');
    }
  };

  renderSKBAttachment = () => {
    if (this.state.skb === "Y") {
      return (
        <Link
        href=""
        onClick={this.handleRedirect.bind(this)}
        target="_blank"
      >
        {this.state.fileSKB.filename}
      </Link>
      );
    }
  };


  handleApprove = () => {
    let url = "/api/v1/claim/approve-principal";
    let { id } = this.props.match.params;
    let param = {
      claim_id: id,
      status: "A",
    };
    this.setState({ loading: true });
    request.post(url, param, {
      success: function (response) {
        this.setState({ loading: false, success: "Claim has been approved" });
        window.scrollTo(0, 0);
        let app = this;
        window.setTimeout(() => {
          app.props.history.push("/admin/claim/approval");
        }, 2000);
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  handleReject = () => {
    let url = "/api/v1/claim/approve-principal";
    let { id } = this.props.match.params;
    let param = {
      claim_id: id,
      status: "R",
    };
    this.setState({ loading: true });
    request.post(url, param, {
      success: function (response) {
        this.setState({ loading: false, success: "Claim has been rejected" });
        window.scrollTo(0, 0);
        let app = this;
        window.setTimeout(() => {
          app.props.history.push("/admin/claim/approval");
        }, 2000);
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  mappingBadge = (status) => {
    let label = "";
    let classname = "";
    console.log(status);
    switch (status) {
      case "A":
        label = "APPROVE";
        classname = "badge badge-success";
        break;
      case "P":
        label = "PROPOSE";
        classname = "badge badge-info";
        break;
      case "R":
        label = "REJECT";
        classname = "badge badge-danger";
        break;
      default:
        label = "PROPOSE";
        classname = "badge badge-info";
        break;
    }
    return {
      label: label,
      class: classname,
    };
  };

  handleBack = () => {
    let qs = this.props.location.search;
    if (qs === "?receive") {
      this.props.history.push("/admin/awb/receive");
    } else {
      this.props.history.push("/admin/awb/submit");
    }
  };
  render() {
    let badge = this.mappingBadge(this.state.status);
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  <div className="card-body">
                    {this.showError()}
                    {this.showSuccess()}
                    <form className="form-horizontal">
                      <h5>General Info</h5>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Claim Number
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="refNumber"
                                placeholder="Skp"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.claimnumber}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Skp Number
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="refNumber"
                                placeholder="Skp"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.skpnumber}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Program Number
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="programNumber"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.programNumber}
                              />
                            </div>
                          </div>

                          {/* <div className="form-group row">
                                                        <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">Beban</label>
                                                        <div className="col-sm-9">
                                                            <input type="text" autoComplete="off" disabled className="form-control" id="inputEmail3" name="beban" placeholder="Principal" onChange={this.handleChangeInput.bind(this)} value={this.state.beban} />
                                                        </div>
                                                    </div> */}
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Principal
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="principalName"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.principalName}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Reff Number / SKP
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="refNumber"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.refNumber}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Program Type
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="programType"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.programType}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Budget Type
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="budgetType"
                                placeholder="budgetType"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.budgetType}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Program Descriptions
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="description"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.description}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Program Submitted Date
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="submitteddate"
                                value={this.state.submitteddate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Start Date
                            </label>
                            <div className="col-sm-3">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="submitteddate"
                                value={this.state.startDate}
                              />
                            </div>
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-2 col-form-label"
                            >
                              End Date
                            </label>
                            <div className="col-sm-3">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="submitteddate"
                                value={this.state.endDate}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Claim Exp Date
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="submitteddate"
                                value={this.state.claimExpDate}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Program Budget
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="number"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder="Budget"
                                name="budget"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.program_budget}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Assign Budget
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="number"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder="Budget"
                                name="budget"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.assign_budget}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Sales Target
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="number"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder="Sales Target"
                                name="salesTarget"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.sales_target}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Customer PPh Type
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="submitteddate"
                                value={this.state.pphType}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              PPh Rate (%)
                            </label>
                            <div className="col-sm-4">
                              <input
                                disabled
                                type="number"
                                max="100"
                                min="0"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder=""
                                name="pphRate"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.pphRate}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Status
                            </label>
                            <div className="col-md-9 mt-2">
                              <span className={badge.class}>{badge.label}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <h5>Claim Info</h5>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Payment Method
                            </label>
                            <div className="col-sm-9 mt-2">
                              <div className="form-check form-check-inline">
                                <input
                                  disabled
                                  className="form-check-input"
                                  type="radio"
                                  checked={
                                    this.state.paymentMethod === "INV"
                                      ? true
                                      : false
                                  }
                                  name="potongTagihan"
                                  id="inlineRadio1"
                                  value="INV"
                                  onChange={this.handleChangeInput.bind(this)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="inlineRadio1"
                                >
                                  Deduct to receivable
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  disabled
                                  className="form-check-input"
                                  type="radio"
                                  checked={
                                    this.state.paymentMethod === "TRF"
                                      ? true
                                      : false
                                  }
                                  name="potongTagihan"
                                  id="inlineRadio2"
                                  value="TRF"
                                  onChange={this.handleChangeInput.bind(this)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="inlineRadio2"
                                >
                                  Transfer
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  disabled
                                  className="form-check-input"
                                  type="radio"
                                  checked={
                                    this.state.paymentMethod === "DEP"
                                      ? true
                                      : false
                                  }
                                  name="potongTagihan"
                                  id="inlineRadio2"
                                  value="DEP"
                                  onChange={this.handleChangeInput.bind(this)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="inlineRadio2"
                                >
                                  Deposit
                                </label>
                              </div>
                            </div>
                          </div>
                          {this.renderNorek()}
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              NPWP / NIK
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="npwp"
                                placeholder="NPWP"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.npwp}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Customer PPh Type
                            </label>
                            <div className="col-sm-9">
                              {this.renderLovPPh()}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Rate <small>(%)</small>
                            </label>
                            <div className="col-sm-3">
                              <input
                                disabled
                                type="number"
                                autoComplete="off"
                                max="100"
                                min="0"
                                className="form-control"
                                id="inputEmail3"
                                name="pphRate"
                                placeholder=""
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.pphRate}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              DPP
                            </label>
                            <div className="col-sm-9">
                              <input
                                disabled
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="dpp"
                                placeholder=""
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.dpp}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              PPN
                            </label>
                            <div className="col-sm-9">
                              <input
                                disabled
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="ppn"
                                placeholder=""
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.ppn}
                              />
                            </div>
                          </div>
                          {this.renderTax()}
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              SKB
                            </label>
                            <div className="col-sm-1 mt-2">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  disabled
                                  type="checkbox"
                                  checked={
                                    this.state.skb === "Y" ? true : false
                                  }
                                  name="skb"
                                  id="inlineRadio1"
                                  value="Y"
                                />
                              </div>
                            </div>
                            {this.renderSKBAttachment()}
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              PPh
                            </label>
                            <div className="col-sm-9">
                              <input
                                disabled
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="pph"
                                placeholder=""
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.pph}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Total Claim
                            </label>
                            <div className="col-sm-9">
                              <input
                                disabled
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="totalAmount"
                                placeholder=""
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.totalAmount}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          {this.renderTableInvoice()}
                        </div>
                      </div>
                      <hr />
                      <h5>Attachments</h5>
                      <div className="row mb-3">
                        <div className="col-md-12">
                          {this.renderDocument()}
                          {/* <div className="row border-bottom">
                                                        <div className="col-md-2 mt-2">Dokumen Lain</div>
                                                        <div className="col-md-6 mt-2"><Link to={{ pathname: this.state.fileLain.path }} target="_blank">{this.state.fileLain.filename}</Link></div>
                                                    </div> */}
                          <div className="row border-bottom">
                            <div className="col-md-2 mt-2">
                              Additional Document
                            </div>
                            <div className="col-md-6 mt-2">
                              {/* <Link
                                to={{ pathname: this.state.fileTambahan.path }}
                                target="_blank"
                              >
                                {this.state.fileTambahan.filename}
                              </Link> */}
                              <a style={{ color: "blue" }} onClick={() => this.downloadAttachment(this.state.fileTambahan)}>
                                {this.state.fileTambahan.filename}
                              </a>
                            </div>
                          </div>
                          <div className="row border-bottom">
                            <div className="col-md-2 mt-2">E-Bupot</div>
                            <div className="col-md-6 mt-2">
                              <a style={{ color: "blue" }} onClick={() => this.downloadAttachment(this.state.fileBupot)}>
                                {this.state.fileBupot.filename}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <button
                            type="button"
                            className="btn btn-warning"
                            onClick={this.handleBack.bind(this)}
                          >
                            <i className="fas fa-arrow-left"></i> Back
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Loader fullPage loading={this.state.loading} />
      </div>
    );
  }
}

export default Detail;
